import { render, staticRenderFns } from "./related_issues_root.vue?vue&type=template&id=33674a88&"
import script from "./related_issues_root.vue?vue&type=script&lang=js&"
export * from "./related_issues_root.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports